module.exports = __webpack_public_path__ + "img/tu2-2.d6bc31ec.png";